
(function () {
  'use strict';

  function enhance(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll('.sr-feature'), function (card) {
      if (card.getAttribute('data-sr-enh')) return;
      card.setAttribute('data-sr-enh', '1');
      var sp = card.querySelector('span');
      if (!sp) return;
      if (sp.scrollHeight > sp.clientHeight + 3) {
        card.classList.add('sr-more');
        card.addEventListener('click', function () { card.classList.toggle('sr-open'); });
      }
    });
  }

  function boot() { enhance(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.SpecsRenderer = { enhance: enhance };
})();
